import React, { Component } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Typeahead } from 'react-bootstrap-typeahead';
import { toast } from 'react-toastify';

// Validation schema
const validationSchema = Yup.object({
  name: Yup.string().required('Name is required'),
  biography: Yup.string().required('Biography is required'),
});

class CreateMember extends Component {
  state = {
    photo: '',
    file: {},
    awsKeys: {},
    disableUpload: false,
    instrument: null,
    photoUpload: false,
    isUploading: false,
    MemberToEdit: {},
    showFollowing: null,
  };

  // Reset form state
  resetFormState = () => {
    this.setState({
      photo: '',
      file: {},
      awsKeys: {},
      disableUpload: false,
      instrument: null,
      photoUpload: false,
      isUploading: false,
      MemberToEdit: {},
      showFollowing: null,
    });
    if (this.typeahead) {
      this.typeahead.getInstance().clear();
    }
  };

  onSubmit = async (values, { resetForm }) => {
    const { photo } = this.state;
    const instrument_id = this.state.instrument[0] && this.state.instrument[0].id;
    const artist_id = this.props.memberInfo.currentArtist.id;

    await this.props.memberInfo.createMember({
      instrument_id,
      artist_id,
      photo,
      name: values.name,
      biography: values.biography
    });
    this.props.memberInfo.getArtistByID('edit', artist_id);

    // Reset form and state
    resetForm();
    this.resetFormState();
  };

  onFileChange = async (eve) => {
    this.setState({
      photoUpload: false,
      disableUpload: false,
    });

    const file = eve.target.files[0];
    const getAwsKey = this.props.memberInfo.getAwsKey;
    const fileName = file.name.replace(/ /g, '_');
    const awsKeys = await getAwsKey({ key: `artists/members/images/${fileName}` });

    this.setState({
      file,
      photo: `${awsKeys.action}${awsKeys.key}`,
      awsKeys,
      disableUpload: true,
    }, () => {
      if (Object.keys(this.state.MemberToEdit).length > 0) {
        const updatedMember = { ...this.state.MemberToEdit, photo: this.state.photo };
        this.setState({ MemberToEdit: updatedMember });
      }
    });
  };

  uploadAudio = (label) => async (eve) => {
    eve.preventDefault();
    if (label !== 'editMember' && !this.state.awsKeys.action) {
      toast.error('please try again.');
      return;
    }

    const form = document.getElementById('uploadPhoto');
    const data = new FormData(form);

    try {
      this.setState({ isUploading: true });

      if (label !== 'editMember') {
        await fetch(this.state.awsKeys.action, { method: 'POST', body: data });
        toast.success('Audio uploaded successfully.');
      }

      this.setState({
        photoUpload: true,
        isUploading: false,
      });

      if (label === 'editMember') {
        this.editMember();
      }
    } catch (error) {
      toast.error('Something went wrong while uploading video.');
      this.setState({ isUploading: false });
    }
  };

  editMember = async () => {
    const { artist_id, biography, instrument, instrument_id, id, sequence, name } = this.state.MemberToEdit;

    await this.props.memberInfo.editMember({
      artist_id,
      biography,
      instrument,
      instrument_id,
      id,
      sequence: Number(sequence),
      name,
    });

    this.resetFormState();
  };

  onDelete = async (member) => {
    await this.props.memberInfo.deleteMember(member);
    const artist_id = this.props.memberInfo.currentArtist.id;
    this.props.memberInfo.getArtistByID('edit', artist_id);
  };

  Show = (i) => {
    const members = this.props.memberInfo.currentArtist.members;
    const memberToEdit = members[i];
    this.setState({
      showFollowing: i,
      MemberToEdit: memberToEdit || {},
    });
  };

  updateMemberField = (field, value) => {
    const updatedMember = { ...this.state.MemberToEdit, [field]: value };
    this.setState({ MemberToEdit: updatedMember });
  };

  getPieceInstrument = () => {
    const members = this.props.memberInfo.currentArtist?.members;
    if (!members) return null;

    return members.map((member, i) => (
      <div key={i}>
        {this.state.showFollowing === i && (
          <div>
            <div className="row">
              <div className="col-md-3">
                <label>Name</label>
              </div>
              <div className="col-md-9">
                <input
                  placeholder="Name"
                  type="text"
                  value={this.state.MemberToEdit.name || ''}
                  onChange={(e) => this.updateMemberField('name', e.target.value)}
                  className="form-control"
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-3">
                <label>Biography</label>
              </div>
              <div className="col-md-9 form-group">
                <input
                  placeholder="Biography"
                  type="text"
                  value={this.state.MemberToEdit.biography || ''}
                  onChange={(e) => this.updateMemberField('biography', e.target.value)}
                  className="form-control"
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-3">
                <label>Audio File</label>
              </div>
              <div className="col-md-9 form-group">
                <form id="uploadFileEdit" method="post" encType="multipart/form-data">
                  <input
                    id="uploadPieceInstrumentPrinted"
                    type="file"
                    name="file"
                    onChange={this.onFileChange}
                  />
                </form>
              </div>
            </div>

            <div className="row">
              <div className="col-md-3">
                <label>Order</label>
              </div>
              <div className="col-md-9">
                <input
                  placeholder="Order"
                  type="number"
                  value={this.state.MemberToEdit.sequence || ''}
                  onChange={(e) => this.updateMemberField('sequence', e.target.value)}
                  className="form-control"
                />
              </div>
            </div>

            <div>
              <form
                id="uploadAudioEdit"
                method="post"
                encType="multipart/form-data"
                onSubmit={this.uploadAudio('editMember')}
              >
                <button
                  type="submit"
                  className="cus-btn-primary btn-sm submitButton"
                  style={{ margin: '10px' }}
                >
                  {this.state.isUploading ? <span className="spinner" /> : <span>Save</span>}
                </button>
                <button
                  type="button"
                  className="cus-btn-danger btn-sm submitButton"
                  style={{ margin: '10px' }}
                  onClick={() => this.setState({ showFollowing: null })}
                >
                  Cancel
                </button>
              </form>
            </div>
          </div>
        )}

        {this.state.showFollowing !== i && (
          <div className="member-list" key={member.id}>
            {this.props.accessMode === 'edit' && (
              <React.Fragment>
                <span
                  className="glyphicon glyphicon-remove-circle remove"
                  aria-hidden="true"
                  onClick={() => this.onDelete(member)}
                />
                <span
                  className="glyphicon glyphicon-edit"
                  aria-hidden="true"
                  onClick={() => this.Show(i)}
                  style={{
                    fontSize: '19px',
                    display: 'inline-block',
                    color: 'green',
                    top: '-15px',
                    right: '15px',
                    position: 'absolute',
                  }}
                />
              </React.Fragment>
            )}

            <div className="row">
              <div className="col-md-3">
                <label>Name</label>
              </div>
              <div className="col-md-9">{member.name}</div>
            </div>
            <div className="row">
              <div className="col-md-3">
                <label>Biography</label>
              </div>
              <div className="col-md-9">{member.biography}</div>
            </div>
            <div className="row">
              <div className="col-md-3">
                <label>Audio File</label>
              </div>
              <div className="col-md-9">{member.photo}</div>
            </div>
            <div className="row">
              <div className="col-md-3">
                <label>Order</label>
              </div>
              <div className="col-md-9">{member.sequence}</div>
            </div>
            <hr />
          </div>
        )}
      </div>
    ));
  };

  render() {
    const { isCreating, instruments } = this.props.memberInfo;
    const { accessMode } = this.props;
    const { awsKeys, disableUpload, instrument, photoUpload } = this.state;

    return (
      <section className="well create-member">
        {this.getPieceInstrument()}

        {accessMode === 'edit' && (
          <Formik
            initialValues={{
              name: '',
              biography: '',
            }}
            validationSchema={validationSchema}
            onSubmit={this.onSubmit}
          >
            {({ values, errors, touched, handleChange, handleBlur, isSubmitting, isValid }) => (
              <Form>
                <div className="row">
                  <div className="col-md-3">
                    <label>Name</label>
                  </div>
                  <div className="col-md-9">
                    <input
                      name="name"
                      placeholder="Name"
                      type="text"
                      value={values.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className="form-control"
                    />
                    {errors.name && touched.name && (
                      <div style={{ color: 'red', fontSize: '12px' }}>{errors.name}</div>
                    )}
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-3">
                    <label>Biography</label>
                  </div>
                  <div className="col-md-9">
                    <input
                      name="biography"
                      placeholder="Biography"
                      type="text"
                      value={values.biography}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className="form-control"
                    />
                    {errors.biography && touched.biography && (
                      <div style={{ color: 'red', fontSize: '12px' }}>{errors.biography}</div>
                    )}
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-3">
                    <label>Instrument</label>
                  </div>
                  <div className="col-md-9">
                    <Typeahead
                      onChange={(selected) => this.setState({ instrument: selected })}
                      labelKey="name"
                      options={instruments || []}
                      selected={instrument}
                      placeholder="Instrument"
                      ref={(typeahead) => (this.typeahead = typeahead)}
                    />
                  </div>

                  <div className="col-md-3">
                    <label>Photo</label>
                  </div>
                  <div className="col-md-9">
                    <form id="uploadPhoto" method="post" encType="multipart/form-data" onSubmit={this.uploadAudio()}>
                      <input type="hidden" name="key" value={awsKeys.key || 'NA'} />
                      <input type="hidden" name="acl" value={awsKeys.acl || 'NA'} />
                      <input type="hidden" name="X-Amz-Credential" value={awsKeys['x-amz-credential'] || 'NA'} />
                      <input type="hidden" name="X-Amz-Algorithm" value={awsKeys['x-amz-algorithm'] || 'NA'} />
                      <input type="hidden" name="X-Amz-Date" value={awsKeys['x-amz-date'] || 'NA'} />
                      <input type="hidden" name="Policy" value={awsKeys.policy || 'NA'} />
                      <input type="hidden" name="X-Amz-Signature" value={awsKeys['x-amz-signature'] || 'NA'} />
                      <input type="file" name="file" onChange={this.onFileChange} />
                      <br />
                      <input
                        type="submit"
                        value="Upload to Amazon S3"
                        className="btn btn-default btn-upload"
                        disabled={!disableUpload}
                      />
                    </form>
                  </div>

                  <div className="create-piece__btn-container">
                    <button
                      className="btn btn-primary btn-block btn-lg"
                      type="submit"
                      disabled={
                        isCreating ||
                        isSubmitting ||
                        !isValid ||
                        !instrument ||
                        instrument.length === 0 ||
                        !photoUpload
                      }
                    >
                      {isCreating || isSubmitting || this.state.isUploading ? (
                        <span className="spinner" />
                      ) : (
                        <span>Create</span>
                      )}
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        )}
      </section>
    );
  }
}

export default CreateMember;
